var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.items, function(item, i) {
      return _c("div", { key: item + "-" + i, staticClass: "column-item" }, [
        _c("div", { staticClass: "description" }, [_vm._v(_vm._s(item.label))]),
        _vm._v(" "),
        _c("div", { staticClass: "value" }, [_vm._v(_vm._s(item.value))])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }